export var Replay;
(function (Replay) {
    Replay[Replay["None"] = 0] = "None";
    Replay[Replay["Backtrack"] = 1] = "Backtrack";
    Replay[Replay["Preset"] = 2] = "Preset";
    Replay[Replay["BacktrackOnly"] = 3] = "BacktrackOnly";
})(Replay || (Replay = {}));
